module.exports = __webpack_public_path__ + "4ddaeab5fbab0e243e1dc933b69335f4.svg";